import { useContext, useEffect, useState } from "react";
import React, { useRef } from 'react';
import WebsocketContext, { WsEvents, useWebsocket } from "../../context/hooks/WebSocket";
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary } from "@mui/material";
import Context from "../../context/Context";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import language from '../../nls/language.json';
// import { Button } from "@mui/material";
import { WagonTableRadio } from "./components/WagonTableRadio";
import { Col, Container, Row, InputGroup, Button, Form } from "react-bootstrap";
import { WagonTableHeader } from "./components/WagonTableHeader";
import { WagonTableBody } from "./components/WagonTableBody";
import { WagonTableConfirmed } from "./components/WagonTableConfirmed";
import { WagonTableCards } from "./components/WagonTableCards";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { DeleteForever } from "@mui/icons-material";
import './wagon.css'
import Loading from "../../components/Loading";
import { ModalDeleteWagon } from "./components/ModalDeleteWagon";
import { ConfirmModal } from "./components/ModalConfirmeWagon";

const INITIAL_VALUE = {
  isEdit: false,
  idWagon: 0
}


export const Wagon = () => {

  const [isEdit, setIsEdit] = useState(INITIAL_VALUE);
  const [active, setActive] = useState(false);
  const [firstPiece, setFirstPiece] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchParts, setSearchParts] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const inputRef = useRef(null);

  //Lógica para moldes no vagão
  const [wagonMoldes, setWagonMoldes] = useState([]);

  const {
    getStatusSideBar,
    selectedCountry,
    wagon, setWagon,
    getFurnace,
    partsByFurnace,
    selectedFurnace,
    confirmedWagon,
    getConfirmedWagon,
    setConfirmedWagon,
    setSelectedWagon,
    selectedWagon,
    postWagon,
    getPartsByFurnace,
    loadingFullScreen,
    setSelectedFurnace,
    moldesEstoque,
    getMoldesEstoque,
    loading,
    setLoading
  } = useContext(Context);

  // useEffect(() => {
  //   refreshStats();
  //   ws.setHandler(WsEvents.BlockedWagon, 'BlockedWagon-Wagon', refreshStats);
  //   ws.setHandler(WsEvents.UpdateWagon, 'UpdateWagon-Wagon', refreshStats);
  // }, [])

  // const ws = useWebsocket();

  // const refreshStats = async () => {
  //   getConfirmedWagon();
  //   getPartsByFurnace(selectedFurnace)
  // }

  useEffect(() => {
    getFurnace()
    setSelectedFurnace(null)
    getMoldesEstoque('BR01');
  }, []);

  useEffect(() => {
    if (partsByFurnace.length) {
      const piece = partsByFurnace.find(({ moldIsTrue, pecasSetor, wagonIsTrue }) =>
        moldIsTrue && !wagonIsTrue && pecasSetor.rack_Buffer != null && !(pecasSetor.pend_Key && pecasSetor.ordem_SetAtual === pecasSetor.pendMotOrigem_SAPSector))
      setFirstPiece(piece);
    }
  }, [partsByFurnace])

  const reset = () => {
    setSelectedWagon({
      tipoCombinacaoPeca: {},
      wagon: {}
    })
    setWagon([])
    setConfirmedWagon([])
    setIsEdit(INITIAL_VALUE)
    getConfirmedWagon()
  }

  function getBackgroundColor(aproveitamento) {
    switch (aproveitamento) {
      case 0:
        return "border-card-wagon-red";
      case 0.5:
        return "border-card-wagon-yellow";
      case 1:
        return "border-card-wagon-green";
      default:
        return "corHP";
    }
  };

  function getColorStatus(status) {
    switch (status) {
      case "BLOQUEADO":
        return "get-color-status-red"
      case "AGUARDANDO MOLDE":
        return "get-color-status-yellow"
      case "LIBERADO":
        return "get-color-status-green"
      default:
    }
  }

  const handleSelectWagon = (param) => {
    // if (!isEdit.isEdit) {
    const item = JSON.parse(JSON.stringify(param))
    setSelectedWagon(item)
    setIsEdit({
      isEdit: true,
      idWagon: item.wagonInfo?.vagao_Key
        ? item.wagonInfo?.vagao_Key
        : item.tipoCombinacaoPeca.tipoComb_Key
    })
    // }
  }

  const handleCancelWagon = (data, isEdit) => {
    setIsEdit(INITIAL_VALUE)
    setSelectedWagon()
    clearWagonMoldes();
    const cancelWagon = data.map((item) => {
      if (item.wagonInfo?.vagao_Key === isEdit?.idWagon)
        if (item.wagonInfo?.vagao_Key && item.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key)
          item.wagon = selectedWagon.wagon
        else if (item.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key)
          item.wagon = selectedWagon.wagon
      return item;
    });
    selectedWagon.wagonInfo?.vagao_Key ? setConfirmedWagon(cancelWagon)
      : setWagon(cancelWagon);
  };

  const checkInArray = (data, peca) => {
    return data.wagon.some((item) => item.ordem_Serial === peca.ordem_Serial)
  }

  function handleAddPecaMolde(peca) {
    if (moldesEstoque.some((d) => peca.molde_Codigo === d.molde_Codigo)) { // Molde disponivel!    
      const indexToRemove = moldesEstoque.findIndex(d => peca.molde_Codigo === d.molde_Codigo);
      if (indexToRemove !== -1) {
        setWagonMoldes([...wagonMoldes, moldesEstoque[indexToRemove]])
        moldesEstoque.splice(indexToRemove, 1);
      }
      return true
    }
    else // Molde indisponível
    {
      toast.error('Não existem moldes disponiveis para a peça ' + peca.ordem_Serial, {
        duration: 3000
      })
      return false
    }
  }

  function clearWagonMoldes() {
    getMoldesEstoque('BR01');
    setWagonMoldes([])
  }

  // const verifyOrderAvailable = async (ordens) => {
  //   try {
  //     const data = await blogFetch.post(`ISAGA_VagoesFornosPecas/verify-part-in-wagon`, ordens);
  //     toast.success('Deu certo', {
  //       duration: 3000
  //     });
  //     return data;
  //   } catch (error) {
  //     toast.error('Erro ao verificar ordens', {
  //       duration: 3000
  //     });
  //     console.log(error);
  //     return error; 
  //   }
  // };

  const handleAddPeca = async (data, peca, status, statusWagon) => {

    // const ordens = [peca.ordem_Serial];
    // const response = await verifyOrderAvailable(ordens);
    // if (response.request.status === 400)
    //   return

    if (!status || statusWagon || (peca.pend_Key && peca.ordem_SetAtual === peca.pendMotOrigem_SAPSector && peca.pend_Status !== "FINALIZADO"))
      return

    const updatedWagon = data.map((item) => {
      if (item.wagonInfo?.vagao_Key && item.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key && !checkInArray(item, peca)) {
        if (handleAddPecaMolde(peca)) {
          item.wagon.push(peca)
        }
      }

      else if (item.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key && !item.wagonInfo?.vagao_Key && !checkInArray(item, peca)) {
        if (handleAddPecaMolde(peca)) {
          item.wagon.push(peca)
        }
      }
      return item;
    });

    selectedWagon.wagonInfo?.vagao_Key
      ? setConfirmedWagon(updatedWagon)
      : setWagon(updatedWagon);

    setActive(true);

  };

  const handleRemovePeca = (wagonData, peca) => {
    const updatedWagon = wagonData.map((item) => {
      if (item.wagonInfo?.vagao_Key && item.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key)
        item.wagon = item.wagon.filter((itemWagon) => itemWagon.ordem_Serial !== peca.ordem_Serial);
      else if (item.tipoCombinacaoPeca?.tipoComb_Key === selectedWagon.tipoCombinacaoPeca?.tipoComb_Key)
        item.wagon = item.wagon.filter((itemWagon) => itemWagon.ordem_Serial !== peca.ordem_Serial);
      return item;
    });

    if (wagonMoldes.some((d) => peca.molde_Codigo === d.molde_Codigo)) {
      const indexToRemove = wagonMoldes.findIndex(d => peca.molde_Codigo === d.molde_Codigo);
      if (indexToRemove !== -1) {
        if (!moldesEstoque.some((d) => wagonMoldes[indexToRemove].molde_Lote === d.molde_Lote)) {
          moldesEstoque.push(wagonMoldes[indexToRemove])
        }
        const newWagonMoldes = [...wagonMoldes];
        newWagonMoldes.splice(indexToRemove, 1);
        setWagonMoldes(newWagonMoldes);
      }
    }

    selectedWagon.wagonInfo?.vagao_Key
      ? setConfirmedWagon(updatedWagon)
      : setWagon(updatedWagon);
    setActive(true);
  };

  const filteredParts = partsByFurnace.filter(
    ({ pecasSetor }) =>
      pecasSetor.ordem_Serial.toString().toLowerCase().includes(searchParts.toLowerCase())
  )

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      inputRef.current.select();
    }
  };

  const handleSearch = () => {
    setSearchParts('');
  };

  const handleClose = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <Navbar />
      <Sidebar />

      <div className="selectFurnace">
        <WagonTableRadio reset={reset} />
      </div>

      <div className={`app_body ${getStatusSideBar()}`}>
        {!loading ? (
          <Container fluid className="p-0 m-0">
            <Row>
              {!!selectedFurnace && (
                <>
                  <Col className="ColunaEsquerda">
                    <h2 className="title_tables my-2">
                      {language[selectedCountry.name].PainelFornos.pecasBuffer}
                    </h2>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <InputGroup>
                          <Form.Control
                            className="w-10"
                            placeholder="Buscar Ordem Serial"
                            value={searchParts}
                            onChange={({ target }) => setSearchParts(target.value)}
                            onKeyDown={handleKeyDown}
                            ref={inputRef}
                          />
                          <Button className="bg-transparent text-black border border-1 border-solid border-gray-300" onClick={handleSearch}>
                            X
                          </Button>
                          <Button className="button-buscar-vagao">
                            Buscar
                          </Button>
                        </InputGroup>
                      </div>
                      <Button
                        className="status-molde-button-form w-20 "
                        onClick={() => {
                          postWagon(firstPiece.pecasSetor, selectedFurnace, firstPiece.moldIsTrue, firstPiece.wagonIsTrue);
                          getMoldesEstoque('BR01');
                          clearWagonMoldes();
                        }}
                        disabled={!firstPiece}
                      >
                        {language[selectedCountry.name].PainelFornos.btnMontarVagao}
                      </Button>
                    </div>

                    <div className="tableFixHead tableFixHeadOverflow filawrap">
                      <table className="table text-center mt-4">
                        <thead>
                          {Object.entries(language[selectedCountry.name].Dashboard.pecasSetor.tableHeaderWagon)
                            .map(([key, value]) => (
                              <WagonTableHeader
                                key={value}
                                header={key}
                              />
                            ))}
                        </thead>
                        <tbody>
                          <WagonTableBody
                            data={filteredParts}
                            isEdit={isEdit}
                            handleAddPeca={handleAddPeca}
                            active={active}
                            reset={reset}
                          />
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  {wagon.length <= 0 && selectedFurnace !== undefined ? (
                    <Col className="ColunaDireita">
                      <div className="">
                        <h2 className=" title_tables my-3">
                          {language[selectedCountry.name].PainelFornos.vagoesNaFila}
                        </h2>
                        <div className="tableFixHead tableFixHeadOverflow filawrap text-center">
                          {confirmedWagon.filter((item) => item.tipoCombinacaoPeca.forno === selectedFurnace).map((item, itemKey) => (
                            <>
                              {showModal && <ModalDeleteWagon showModal={showModal} setShowModal={setShowModal} item={selectedWagon} />}
                              <Accordion
                                className={`${item.wagonInfo?.vagao_Key === selectedWagon?.wagonInfo?.vagao_Key
                                  ? "selectWagon" : ""} mb-3 border border-dark`}
                                key={`resultadoRelacionado-${itemKey}`}>
                                <AccordionSummary>
                                  <table>
                                    <thead>
                                      <th className="p-1 w-25">NOME COMBINAÇÃO</th>
                                      <th className="p-1 w-25">VAGÃO SERIAL</th>
                                      <th className="p-1 w-25">M² VAGÃO</th>
                                      <th className="p-1 w-25">STATUS VAGÃO</th>
                                    </thead>
                                    <tbody>
                                      <td className="p-1">{item.tipoCombinacaoPeca.comb_Nome}</td>
                                      <td className="p-1">{`${item.wagonInfo.vagao_Serial}`}</td>
                                      <td className="p-1">{`${(parseFloat(item.wagon.reduce((sum, item) => sum + item.m2_Peca, 0)) / 4.5).toFixed(3)}`}</td>
                                      <td className={`${getColorStatus(item.wagonInfo.status_Vagao)} p-1`}>
                                        {`${item.wagonInfo.status_Vagao}`}
                                      </td>
                                    </tbody>
                                  </table>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <table className="table m-0 tableFixHeadOverflow text-center">
                                    <thead>
                                      {Object.entries(language[selectedCountry.name].Dashboard.pecasSetor.tableHeaderSelectedWagon)
                                        .map(([key, value]) => (
                                          <WagonTableHeader
                                            key={value}
                                            header={key}
                                          />
                                        ))}
                                    </thead>
                                    <tbody>
                                      <WagonTableConfirmed
                                        data={item}
                                        isEdit={isEdit}
                                        handleRemovePeca={handleRemovePeca}
                                      />
                                    </tbody>
                                  </table>
                                </AccordionDetails>
                                <AccordionActions>
                                  <Button
                                    onClick={() => handleSelectWagon(item)}
                                    className="status-molde-button-form me-3 p-1 bd-highlight"
                                  >
                                    {language[selectedCountry.name].PainelFornos.btnSelecionar}
                                  </Button>
                                  <Button
                                    onClick={() => handleCancelWagon(confirmedWagon, isEdit)}
                                    disabled={isEdit.idWagon != item.wagonInfo.vagao_Key}
                                    className="p-1 bd-highlight"
                                    variant="secondary"
                                  >
                                    {language[selectedCountry.name].PainelFornos.btnCancelar}
                                  </Button>

                                  <Button
                                    onClick={() => setShowModal(true)}
                                    disabled={isEdit.idWagon != item.wagonInfo.vagao_Key}
                                    className="p-1 bd-highlight ms-3"
                                    variant="danger"
                                    color="error"
                                  >
                                    <DeleteForever />
                                  </Button>

                                  <Button
                                    onClick={() => setShowConfirmModal(true)}
                                    disabled={isEdit.idWagon != item.wagonInfo.vagao_Key
                                      || item.wagon.some(piece => piece.vagoes_Fornos_Pecas_Status_Molde === "MANUTENCAO")}
                                    className="ms-auto p-1 bd-highlight"
                                    variant="success"
                                  >
                                    {language[selectedCountry.name].PainelFornos.btnConfirmar}
                                  </Button>
                                  <ConfirmModal
                                    show={showConfirmModal}
                                    handleClose={handleClose}
                                    wagon={confirmedWagon}
                                    partsByFurnace={partsByFurnace}
                                    selectedWagon={selectedWagon}
                                    setIsEdit={setIsEdit}
                                    INITIAL_VALUE={INITIAL_VALUE}
                                    reset={reset}
                                    setShowConfirmModal={setShowConfirmModal}
                                  />
                                </AccordionActions>
                              </Accordion >
                            </>
                          ))}
                        </div>
                      </div >
                    </Col>
                  ) :
                    <Col className="ColunaDireita">
                      <div>
                        <div className="d-flex justify-content-between">
                          <div className="w-25"></div>
                          <h2 className="title_tables me-2">
                            {language[selectedCountry.name].PainelFornos.vagaoSugerido}
                          </h2>
                          <button
                            className="w-25 btn "
                            color="error"
                            onClick={() => reset()}>
                            {language[selectedCountry.name].PainelFornos.btnReset}
                          </button>
                        </div>
                        <div className="tableFixHead tableFixHeadOverflow">
                          {wagon.map((wagonCards, index) => (
                            <div className="pb-3" key={`table-${index}`}>
                              <div className={`${wagonCards?.tipoCombinacaoPeca?.tipoComb_Key === selectedWagon?.tipoCombinacaoPeca?.tipoComb_Key
                                ? "selectWagon" : ""}  ${getBackgroundColor(wagonCards?.tipoCombinacaoPeca?.aproveitamento)} card`} >

                                <div className="card-body p-1">

                                  <div className="d-flex justify-content-between align-items-center p0">
                                    <p className="title_tables m-0 p-0 nome-sugerido">
                                      {wagonCards.tipoCombinacaoPeca.comb_Nome}
                                    </p>
                                    <p className="title_tables m-0 p-0 forno-sugerido">
                                      {`${wagonCards.tipoCombinacaoPeca.forno}`}
                                    </p>
                                    <p className="text-bold title_tables m-0 jogo-sugerido">
                                      {`${parseFloat(wagonCards.wagon.reduce((sum, item) => sum + item.m2_Peca, 0)).toFixed(3)}`}
                                    </p>
                                  </div>

                                  <table className="table text-center m-0">
                                    <thead>
                                      {Object.entries(language[selectedCountry.name].Dashboard.pecasSetor.tableHeaderCardsWagon)
                                        .map(([key, value]) => (
                                          <WagonTableHeader
                                            key={value}
                                            header={key}
                                          />
                                        ))}
                                    </thead>
                                    <tbody className="overflow">
                                      <WagonTableCards
                                        isEdit={isEdit}
                                        data={wagonCards}
                                        handleRemovePeca={handleRemovePeca}
                                      />
                                    </tbody>
                                  </table>
                                  <div className="d-flex bd-highlight pt-1">
                                    <Button
                                      onClick={() => handleSelectWagon(wagonCards)}
                                      className="status-molde-button-form me-3 p-1 bd-highlight"
                                    >
                                      {language[selectedCountry.name].PainelFornos.btnSelecionar}
                                    </Button>

                                    <Button
                                      onClick={() => handleCancelWagon(wagon)}
                                      disabled={isEdit.idWagon != wagonCards?.tipoCombinacaoPeca?.tipoComb_Key}
                                      className="status-molde-button-form me-3 p-1 bd-highlight"
                                      variant="secondary"
                                    >
                                      {language[selectedCountry.name].PainelFornos.btnCancelar}
                                    </Button>

                                    <>
                                      <Button
                                        onClick={() => {
                                          setShowConfirmModal(true)
                                          handleSearch()
                                        }}
                                        disabled={isEdit.idWagon !== wagonCards?.tipoCombinacaoPeca?.tipoComb_Key}
                                        className="p-1 bd-highlight"
                                        variant="success"
                                      >
                                        {language[selectedCountry.name].PainelFornos.btnConfirmar}
                                      </Button>

                                      <ConfirmModal
                                        show={showConfirmModal}
                                        handleClose={handleClose}
                                        wagon={wagon}
                                        partsByFurnace={partsByFurnace}
                                        selectedWagon={selectedWagon}
                                        setIsEdit={setIsEdit}
                                        INITIAL_VALUE={INITIAL_VALUE}
                                        reset={reset}
                                        setShowConfirmModal={setShowConfirmModal}
                                      />
                                    </>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  }
                </>
              )}
            </Row>
          </Container>
        ) : (<Loading />)}
      </div >
    </>
  );
}